import { HgUnitsOfMeasurement } from '@/models/HgUnitsOfMeasurement';

type AttributeValue = string | number | boolean | undefined;

export interface ReAttribute {
  field: string;
  value: AttributeValue;
  unit?: string;
}

export type AttributeValueRecord = Record<string, AttributeValue>;

const UNIT_OF_MEASUREMENT_SUFFIX = {
  [HgUnitsOfMeasurement.M]: 'm',
  [HgUnitsOfMeasurement.M2]: 'm<sup>2</sup>',
  [HgUnitsOfMeasurement.M3]: 'm<sup>3</sup>',
  [HgUnitsOfMeasurement.KG]: 'kg',
  [HgUnitsOfMeasurement.KGM2]: 'kg/m<sup>2</sup>',
  [HgUnitsOfMeasurement.PERCENT]: '%',
};

export const ATTRIBUTES_UNITS_OF_MEASUREMENT: Record<string, string> = {
  livingSpace: UNIT_OF_MEASUREMENT_SUFFIX.M2,
  totalFloorSpace: UNIT_OF_MEASUREMENT_SUFFIX.M2,
  singleFloorSpace: UNIT_OF_MEASUREMENT_SUFFIX.M2,
  lotSize: UNIT_OF_MEASUREMENT_SUFFIX.M2,
  buildingFloorSize: UNIT_OF_MEASUREMENT_SUFFIX.M2,
  cubage: UNIT_OF_MEASUREMENT_SUFFIX.M3,
  ceilingHeight: UNIT_OF_MEASUREMENT_SUFFIX.M,
  hallHeight: UNIT_OF_MEASUREMENT_SUFFIX.M,
  floorLoad: UNIT_OF_MEASUREMENT_SUFFIX.KGM2,
  elevatorCapacity: UNIT_OF_MEASUREMENT_SUFFIX.KG,
  craneCapacity: UNIT_OF_MEASUREMENT_SUFFIX.KG,
  grossPremium: UNIT_OF_MEASUREMENT_SUFFIX.PERCENT,
};
